import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageWrapper } from '../../components/PageWrapper';
import { CreateOrganizationForm } from './CreateOrganizationForm';

const styles = {
    contentBody: { marginTop: '20px' },
};

export const CreateOrganizationPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <PageWrapper title={t('CREATE_ORGANIZATION_PAGE.TITLE')} sx={styles.contentBody}>
            <CreateOrganizationForm />
        </PageWrapper>
    );
};
